import * as React from 'react';
import { Switch, Redirect, RouteComponentProps } from 'react-router-dom';
import Dashboard from './components/dashboard/dashboard';
import Layout from './components/layout/layout';
import Report from './components/report/report';
import Help from './components/help/help';
import Paths from './models/enums/paths';
import Clients from './components/management/clients/clients';
import Support from './components/support/support';
import ChangePassword from './components/login/change-password';
import { SupportProvider } from './shared/support-context';
import { PagedClientProvider } from './shared/paginated-client-context';
import { PagedUserProvider } from './shared/paginated-user-context';
import RequestDetails from './components/support/requestView/request-details';
import AddClient from './components/management/clients/clientAdmin/add-client';
import Users from './components/management/users/users';
import AddUser from './components/management/users/manageUser/addUser';
import EditUser from './components/management/users/manageUser/editUser';
import GlobalAnnouncements from './components/management/announcements/global-announcements';
import AdminClient from './components/management/clients/clientAdmin/adminClient';
import ClientHelpDocuments from './components/management/clientHelpDocuments/client-help-documents';
import { HelpDocumentsProvider } from './shared/help-documents-context';
import AddGlobalDocument from './components/management/clientHelpDocuments/add-global-document';
import EditGlobalDocument from './components/management/clientHelpDocuments/edit-global-document';
import ManageRevisions from './components/management/clientHelpDocuments/manage-revisions';
import { PagedRevisionsProvider } from './shared/paginated-revisions';
import { SecureRoute } from '@okta/okta-react';
import { AppContext } from './shared/app-context';
import Segments from './components/segments/segments';
import CreateSegment from './components/segments/create-segment';
import AdminSegments from './components/segments/admin-segments';
import SegmentsRoutesWrapper from './segments-routes-wrapper';
import PushSegment from './components/segments/push-segment/push-segment';
import ViewPushDetails from './components/segments/push-segment/view-push-details';
import SegmentTab from './components/segments/segment-tabs';

const LayoutRouter = () => {
  const { state } = React.useContext(AppContext);

  const userInterface =
    window.env.USER_INTERFACE !== null && window.env.USER_INTERFACE !== undefined
      ? window.env.USER_INTERFACE
      : 'default';

  if (userInterface === 'management') {
    return (
      <Layout>
        <Switch>
          <SecureRoute path={Paths.GlobalHelpDocuments}>
            <HelpDocumentsProvider>
              <Switch>
                <SecureRoute path={Paths.AddGlobalHelpDocument} exact component={AddGlobalDocument} />
                <SecureRoute
                  path={`${Paths.EditGlobalHelpDocument}/:revisions?`}
                  exact={false}
                  component={EditGlobalDocument}
                />
                <SecureRoute path={Paths.ViewGlobalHelpDocumentRevisions} exact>
                  <PagedRevisionsProvider>
                    <ManageRevisions isGlobal />
                  </PagedRevisionsProvider>
                </SecureRoute>
                <SecureRoute path={`${Paths.GlobalHelpDocuments}/:document?`} exact component={ClientHelpDocuments} />
              </Switch>
            </HelpDocumentsProvider>
          </SecureRoute>
          <SecureRoute path="/clients">
            <Switch>
              <SecureRoute path="/clients" exact>
                <PagedClientProvider>
                  <Clients />
                </PagedClientProvider>
              </SecureRoute>
              <SecureRoute path="/clients/create" exact={true} component={AddClient} />
              <SecureRoute path={Paths.EditClient} exact={false} component={AdminClient} />
            </Switch>
          </SecureRoute>
          <SecureRoute path="/users">
            <Switch>
              <SecureRoute path="/users" exact={true}>
                <PagedUserProvider>
                  <Users />
                </PagedUserProvider>
              </SecureRoute>
              <SecureRoute path="/users/create" exact={true} component={AddUser} />
              <SecureRoute path="/users/:userId/edit" exact={false} component={EditUser} />
            </Switch>
          </SecureRoute>
          <SecureRoute path="/announcements" exact={true} component={GlobalAnnouncements} />
          <SecureRoute path="/change-password" exact={true} component={ChangePassword} />
          <SecureRoute exact={true} path={Paths.Segments} component={AdminSegments} />
          <SecureRoute path={Paths.PushDetails} component={ViewPushDetails} />
          <SecureRoute path={Paths.Segment} component={SegmentTab} />
          <Redirect from="*" to="/clients" />
        </Switch>
      </Layout>
    );
  } else {
    return (
      <Layout>
        <Switch>
          <SecureRoute exact={true} path="/reports" component={Dashboard} />
          <SecureRoute
            path="/reports/:reportId"
            exact={false}
            component={(routeProps: RouteComponentProps) => <Report clientId={state.clientId} {...routeProps} />}
          />
          <SecureRoute exact={false} path={Paths.Segments}>
            <SegmentsRoutesWrapper>
              <Switch>
                <SecureRoute exact={true} path={Paths.Segments} component={Segments} />
                <SecureRoute exact={true} path={Paths.NewSegment} component={CreateSegment} />
                <SecureRoute exact={true} path={Paths.PushSegment} component={PushSegment} />
                <SecureRoute exact={true} path={Paths.PushDetails} component={ViewPushDetails} />
                <SecureRoute path={Paths.Segment} component={SegmentTab} />
              </Switch>
            </SegmentsRoutesWrapper>
          </SecureRoute>
          <SecureRoute exact={true} path="/change-password" component={ChangePassword} />
          <SecureRoute path={Paths.Help + '/:document?'} exact={false} component={Help} />
          {/* Outer support route allows redirect after SupportProvider */}
          <SecureRoute exact={false} path={Paths.Support}>
            <SupportProvider>
              <SecureRoute path={Paths.Support} exact={true} component={Support} />
              <SecureRoute path={Paths.AddRequest} exact={false} component={RequestDetails} />
            </SupportProvider>
          </SecureRoute>
          {/* redirect anything else to dashboard */}
          <Redirect from="*" to="/reports" />
        </Switch>
      </Layout>
    );
  }
};
export default LayoutRouter;
